// BOLODOO shipping business days v1
(function () {
  "use strict";

  if (window.__bolodooNativeWeddingDressFormV2) return;
  window.__bolodooNativeWeddingDressFormV2 = true;

  var COUNTRY_NAMES = {
    AU: "Australia",
    AT: "Austria",
    CA: "Canada",
    FR: "France",
    DE: "Germany",
    IE: "Ireland",
    IT: "Italy",
    NZ: "New Zealand",
    SE: "Sweden",
    CH: "Switzerland",
    GB: "United Kingdom",
    US: "United States"
  };

  var PRICING_PROFILES = {
    default: {
      modes: {
        standard: { label: "Standard", tailoring: [7, 12], adjustment: 0 },
        rush: { label: "Rush", tailoring: [4, 7], adjustment: 20 }
      },
      sizeAdjustments: {
        "US16W": 10,
        "US18W": 10,
        "US20W": 15,
        "US22W": 15,
        "US24W": 20,
        "US26W": 20,
        "Custom Size": 20
      }
    },
    weddingDress: {
      modes: {
        standard: { label: "Standard", tailoring: [15, 19], adjustment: 0 },
        rush: { label: "Rush", tailoring: [9, 15], adjustment: 60 }
      },
      sizeAdjustments: {
        "US16W": 30,
        "US18W": 30,
        "US20W": 50,
        "US22W": 50,
        "US24W": 60,
        "US26W": 60,
        "Custom Size": 60
      }
    }
  };

  var SIZE_ROWS = [
    { key: "US0", regions: { US: "US0", UK: "UK4", EU: "EU32" }, inch: ["31½", "24½", "34¾", "58", "63"], cm: [80, 62, 88, 147, 160] },
    { key: "US2", regions: { US: "US2", UK: "UK6", EU: "EU34" }, inch: ["32½", "25½", "35¾", "58", "63"], cm: [83, 65, 91, 147, 160] },
    { key: "US4", regions: { US: "US4", UK: "UK8", EU: "EU36" }, inch: ["33½", "26½", "36¾", "58", "63"], cm: [85, 68, 94, 147, 160] },
    { key: "US6", regions: { US: "US6", UK: "UK10", EU: "EU38" }, inch: ["34½", "27½", "37¾", "59", "65"], cm: [88, 70, 96, 150, 165] },
    { key: "US8", regions: { US: "US8", UK: "UK12", EU: "EU40" }, inch: ["35½", "28½", "38¾", "59", "65"], cm: [90, 72, 98, 150, 165] },
    { key: "US10", regions: { US: "US10", UK: "UK14", EU: "EU42" }, inch: ["36½", "29½", "39¾", "60", "67"], cm: [93, 75, 101, 152, 170] },
    { key: "US12", regions: { US: "US12", UK: "UK16", EU: "EU44" }, inch: ["38", "31", "41¼", "60", "67"], cm: [97, 79, 105, 152, 170] },
    { key: "US14", regions: { US: "US14", UK: "UK18", EU: "EU46" }, inch: ["39½", "32½", "42¾", "61", "69"], cm: [100, 83, 109, 155, 175] },
    { key: "US16", regions: { US: "US16", UK: "UK20", EU: "EU48" }, inch: ["41", "34", "44¼", "61", "69"], cm: [104, 86, 112, 155, 175] },
    { key: "US16W", regions: { US: "US16W", UK: "UK22W", EU: "EU50W" }, inch: ["43", "36¼", "45½", "61", "69"], cm: [109, 92, 116, 155, 175] },
    { key: "US18W", regions: { US: "US18W", UK: "UK24W", EU: "EU52W" }, inch: ["45", "38½", "47½", "61", "69"], cm: [114, 98, 121, 155, 175] },
    { key: "US20W", regions: { US: "US20W", UK: "UK26W", EU: "EU54W" }, inch: ["47", "40¾", "49½", "61", "69"], cm: [119, 104, 126, 155, 175] },
    { key: "US22W", regions: { US: "US22W", UK: "UK28W", EU: "EU56W" }, inch: ["49", "43", "51½", "61", "69"], cm: [124, 109, 131, 155, 175] },
    { key: "US24W", regions: { US: "US24W", UK: "UK30W", EU: "EU58W" }, inch: ["51", "45¼", "53½", "61", "69"], cm: [130, 115, 136, 155, 175] },
    { key: "US26W", regions: { US: "US26W", UK: "UK32W", EU: "EU60W" }, inch: ["53", "47½", "55½", "61", "69"], cm: [135, 121, 141, 155, 175] }
  ];

  var SHIPPING = {
    standard: [5, 12],
    expedited: [3, 5]
  };

  function getPricingProfile(component) {
    // BOLODOO fixed business day templates v1
    var schedules = {
      "3-5-business-days": [3, 5],
      "5-7-business-days": [5, 7],
      "7-9-business-days": [7, 9]
    };
    var schedule = component && component.getAttribute("data-bnd-tailoring-schedule");
    var tailoring = Object.prototype.hasOwnProperty.call(schedules, schedule) ? schedules[schedule] : null;
    if (tailoring) {
      return {
        modes: { standard: { label: "Standard", tailoring: tailoring, adjustment: 0, businessDays: true } },
        sizeAdjustments: PRICING_PROFILES.default.sizeAdjustments
      };
    }
    return component && component.getAttribute("data-bnd-pricing-profile") === "wedding-dress"
      ? PRICING_PROFILES.weddingDress
      : PRICING_PROFILES.default;
  }

  function getMode(key, profile) {
    var activeProfile = profile || PRICING_PROFILES.default;
    return activeProfile.modes[key] || activeProfile.modes.standard;
  }


  // BOLODOO 3-5 business day tailoring v1: fixed processing schedules and all transit durations exclude weekends.
  function addBusinessDays(date, days) {
    var result = new Date(date.getTime());
    while (days > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) days -= 1;
    }
    return result;
  }

  function deliveryRange(start, mode, shipping) {
    var productionEnd = mode.businessDays ? addBusinessDays : addDays;
    return formatDate(addBusinessDays(productionEnd(start, mode.tailoring[0]), shipping[0])) + " - " +
      formatDate(addBusinessDays(productionEnd(start, mode.tailoring[1]), shipping[1]));
  }

  function tailoringLabel(mode) {
    return mode.tailoring[0] + "-" + mode.tailoring[1] + (mode.businessDays ? " Business Days" : " Days");
  }

  function addDays(date, days) {
    var result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  function formatDate(date) {
    var month = date.toLocaleString("en-US", { month: "short", timeZone: "UTC" });
    return month + ". " + date.getUTCDate();
  }

  function formatRange(date, startDays, endDays) {
    return formatDate(addDays(date, startDays)) + " - " + formatDate(addDays(date, endDays));
  }

  function getCountryCode() {
    var shopifyCountry = window.Shopify && window.Shopify.country;
    if (shopifyCountry && COUNTRY_NAMES[String(shopifyCountry).toUpperCase()]) {
      return String(shopifyCountry).toUpperCase();
    }

    var locale = String(navigator.language || "").split("-")[1];
    return COUNTRY_NAMES[locale ? locale.toUpperCase() : ""] ? locale.toUpperCase() : "US";
  }

  function formatAdjustment(value) {
    if (value === 0) return "$0.00";
    return (value > 0 ? "+$" : "-$") + Math.abs(value).toFixed(2);
  }

  function formatCurrency(cents, currency) {
    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency || "USD"
      }).format(Math.max(0, cents) / 100);
    } catch (error) {
      return "$" + (Math.max(0, cents) / 100).toFixed(2);
    }
  }

  function getBasePriceCents(component) {
    var selectedVariant = document.querySelector("variant-radios [data-selected-variant]");
    if (selectedVariant) {
      try {
        var parsed = JSON.parse(selectedVariant.textContent || "{}");
        if (parsed.price !== undefined) return Number(parsed.price) || 0;
      } catch (error) {
        // The Liquid fallback remains available when the theme is mid-refresh.
      }
    }
    return Number(component.getAttribute("data-base-price")) || 0;
  }

  function getSelectedColor() {
    // BOLODOO wedding production colors v1: use the customer's production color, not the base variant label.
    var palette = document.querySelector('[id^="ProductInfo-"] wedding-color-palette');
    if (palette) {
      var choice = palette.querySelector('[data-wcp-choice]:checked');
      return choice ? choice.value : '';
    }
    var picker = document.querySelector("variant-radios");
    if (!picker) return "";
    var fieldset = Array.prototype.find.call(picker.querySelectorAll("fieldset[data-option-position]"), function (item) {
      var label = item.querySelector(".product-form__group-name, .select-label");
      return /\bcolou?r\b/i.test(label ? String(label.textContent || "") : "");
    });
    if (!fieldset) return "";

    var selected = fieldset.querySelector("input:checked, select");
    if (selected && selected.value) return String(selected.value).trim();

    var labelValue = fieldset.querySelector(".product-form__group-name span, .select-label span");
    return labelValue ? String(labelValue.textContent || "").trim() : "";
  }

  function findProductForms(component) {
    var formId = component.getAttribute("data-form-id");
    var primaryForm = formId && document.getElementById(formId);
    var forms = Array.prototype.filter.call(document.querySelectorAll('form[data-type="add-to-cart-form"]'), function (form) {
      return /^product-form/.test(form.id || "") && !/^quick-add-/.test(form.id || "");
    });
    if (primaryForm && forms.indexOf(primaryForm) < 0) forms.unshift(primaryForm);
    return forms;
  }

  function getProductVariantId(component) {
    var selectedVariant = document.querySelector("variant-radios [data-selected-variant]") || document.querySelector("[data-selected-variant]");
    if (selectedVariant) {
      try {
        var parsed = JSON.parse(selectedVariant.textContent || "{}");
        if (parsed.id) return Number(parsed.id);
      } catch (error) {
        // Use the Liquid fallback while the theme variant picker is refreshing.
      }
    }

    var fallbackId = Number(component && component.getAttribute("data-bnd-product-variant-id"));
    return Number.isFinite(fallbackId) && fallbackId > 0 ? fallbackId : 0;
  }

  function syncProductVariantId(component) {
    var variantId = getProductVariantId(component);
    if (!variantId) return;

    findProductForms(component).forEach(function (form) {
      var input = form.querySelector('[name="id"]');
      if (!input) return;
      input.defaultValue = String(variantId);
      input.setAttribute("value", String(variantId));
      input.value = String(variantId);
    });
  }

  function disableYmqProductForm(component) {
    syncProductVariantId(component);
    findProductForms(component).forEach(function (form) {
      form.querySelectorAll('button[name="add"]').forEach(function (button) {
        var wrapper = button.parentElement;
        if (wrapper && wrapper.tagName === "SPAN" && (wrapper.wrapper === true || /cursor:\s*pointer/i.test(wrapper.getAttribute("style") || ""))) {
          wrapper.replaceWith(button);
        }
        button.style.setProperty("pointer-events", "auto", "important");
      });
    });
  }

  function watchNativeProductForm(component) {
    var forms = findProductForms(component);
    forms.forEach(function (form) {
      if (form._bndNativeYmqWatch) return;
      form._bndNativeYmqWatch = new MutationObserver(function () {
        disableYmqProductForm(component);
      });
      form._bndNativeYmqWatch.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style"]
      });
    });
  }

  function setProperty(form, key, value) {
    if (!form) return;
    var input = Array.prototype.find.call(form.querySelectorAll("input[data-bnd-property]"), function (item) {
      return item.getAttribute("data-bnd-property") === key;
    });

    if (!value) {
      if (input) input.remove();
      return;
    }

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.setAttribute("data-bnd-property", key);
      input.name = "properties[" + key + "]";
      form.appendChild(input);
    }
    input.defaultValue = value;
    input.setAttribute("value", value);
    input.value = value;
  }

  function getSizeSelect(component) {
    var root = component.closest("[data-bnd-size-guide-root]");
    return root ? getPortalElement(root, "[data-bnd-size]") : component.querySelector("[data-bnd-size]");
  }

  function getPortalElement(root, selector) {
    if (!root) return null;
    var local = root.querySelector(selector);
    if (local) return local;
    return root._bndPortal ? root._bndPortal.querySelector(selector) : null;
  }

  function getPortalElements(root, selector) {
    if (!root) return [];
    var local = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root._bndPortal) local = local.concat(Array.prototype.slice.call(root._bndPortal.querySelectorAll(selector)));
    return local;
  }

  function hoistDrawer(root) {
    if (!root || root._bndPortal) return;
    var drawer = root.querySelector("[data-bnd-size-drawer]");
    var backdrop = root.querySelector("[data-bnd-drawer-backdrop]");
    if (!drawer || !backdrop || !document.body) return;
    root._bndPortal = document.createElement("div");
    root._bndPortal.className = "bnd-drawer-portal";
    document.body.appendChild(root._bndPortal);
    root._bndPortal.appendChild(backdrop);
    root._bndPortal.appendChild(drawer);
  }

  var CUSTOM_MEASUREMENT_LABELS = {
    bust: "Bust",
    waist: "Waist",
    hips: "Hips",
    hollow_to_floor: "Hollow to Floor",
    height: "Height"
  };

  function getCustomMeasurementValues(root) {
    var values = {};
    if (!root) return values;
    Object.keys(CUSTOM_MEASUREMENT_LABELS).forEach(function (key) {
      var input = getPortalElement(root, '[data-bnd-measurement="' + key + '"]');
      values[key] = input ? String(input.value || "").trim() : "";
    });
    return values;
  }

  function areCustomMeasurementsComplete(root) {
    var values = getCustomMeasurementValues(root);
    return Object.keys(CUSTOM_MEASUREMENT_LABELS).every(function (key) {
      var value = Number(values[key]);
      return values[key] !== "" && Number.isFinite(value) && value > 0;
    });
  }

  function formatCustomMeasurements(root) {
    if (!areCustomMeasurementsComplete(root)) return "";
    var values = getCustomMeasurementValues(root);
    var unit = root && root._bndGuideState && root._bndGuideState.unit === "cm" ? "cm" : "inch";
    return Object.keys(CUSTOM_MEASUREMENT_LABELS).map(function (key) {
      return CUSTOM_MEASUREMENT_LABELS[key] + ": " + values[key] + " " + unit;
    }).join(" | ");
  }

  function syncCustomMeasurementPanel(root, selectedValue) {
    if (!root) return;
    var isCustom = selectedValue === "Custom Size";
    var panel = getPortalElement(root, "[data-bnd-custom-measurements]");
    if (panel) panel.hidden = !isCustom;

    var unit = root._bndGuideState && root._bndGuideState.unit === "cm" ? "cm" : "inch";
    getPortalElements(root, "[data-bnd-measurement-unit]").forEach(function (label) {
      label.textContent = unit;
    });
    getPortalElements(root, "[data-bnd-measurement]").forEach(function (input) {
      input.required = isCustom;
      input.setAttribute("aria-required", String(isCustom));
    });
  }

  function syncSizeButtons(root, selectedValue) {
    if (!root) return;
    getPortalElements(root, "[data-bnd-size-option]").forEach(function (button) {
      var active = button.getAttribute("data-size-value") === selectedValue;
      button.classList.toggle("is-selected", active);
      button.setAttribute("aria-pressed", String(active));
    });
    var isCustom = selectedValue === "Custom Size";
    syncCustomMeasurementPanel(root, selectedValue);
    var confirm = getPortalElement(root, "[data-bnd-confirm-size]");
    if (confirm) {
      var customComplete = areCustomMeasurementsComplete(root);
      confirm.disabled = !selectedValue || (isCustom && !customComplete);
      confirm.setAttribute("aria-disabled", String(confirm.disabled));
      syncConfirmLabel(root, selectedValue);
    }
  }

  /* 从加车打开弹框时，选中尺码后右下角按钮由选尺码改为加车，点击后才真正加车。 */
  function syncConfirmLabel(root, selectedValue) {
    if (!root) return;
    var confirm = getPortalElement(root, "[data-bnd-confirm-size]");
    if (!confirm) return;
    if (!confirm.dataset.bndSelectLabel) {
      confirm.dataset.bndSelectLabel = String(confirm.textContent || "SELECT THIS SIZE").trim() || "SELECT THIS SIZE";
    }
    var pendingAdd = !!root._bndPendingAddForm;
    confirm.textContent = pendingAdd && selectedValue ? "ADD TO CART" : confirm.dataset.bndSelectLabel;
  }

  function chooseSize(root, component, value) {
    var size = getSizeSelect(component);
    if (!size || !value) return;
    component.dataset.bndSizeChosen = "true";
    size.value = value;
    size.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function hideThemeSizePicker() {
    document.querySelectorAll("variant-radios").forEach(function (picker) {
      picker.querySelectorAll("fieldset[data-option-position]").forEach(function (fieldset) {
        var label = fieldset.querySelector(".product-form__group-name, .select-label");
        var labelText = label ? String(label.textContent || "") : "";
        var hasDressSizeValue = Array.prototype.some.call(fieldset.querySelectorAll("input, option"), function (option) {
          return /^US(?:\\d+|\\d+W)$/i.test(String(option.value || option.textContent || "").trim());
        });
        if (/\\bsize\\b/i.test(labelText) || hasDressSizeValue) {
          fieldset.hidden = true;
          fieldset.setAttribute("data-bnd-native-size-hidden", "true");
        }
      });
    });
  }

  function getPropertyValues(component) {
    var size = getSizeSelect(component);
    var requirements = component.querySelector("[data-bnd-requirements]");
    var estimate = component._bndEstimate;
    var standardMode = getMode("standard", getPricingProfile(component));
    var root = component.closest("[data-bnd-size-guide-root]");
    var customMeasurements = size && size.value === "Custom Size" ? formatCustomMeasurements(root) : "";
    return {
      "Color": getSelectedColor(component),
      "Size": size ? size.value : "",
      "Processing Time": estimate ? estimate.tailoring : tailoringLabel(standardMode),
      "Standard delivery": estimate ? estimate.standard : "",
      "Expedited delivery": estimate ? estimate.expedited : "",
      "Custom measurements": customMeasurements,
      "Additional Requirements": requirements ? requirements.value.trim() : ""
    };
  }

  function appendPropertiesToFormData(component, formData) {
    var properties = getPropertyValues(component);
    Object.keys(properties).forEach(function (key) {
      if (properties[key]) formData.set("properties[" + key + "]", properties[key]);
    });
  }

  function syncProperties(component) {
    var properties = getPropertyValues(component);
    findProductForms(component).forEach(function (form) {
      ["Production", "Shipping to"].forEach(function (key) {
        setProperty(form, key, "");
      });
      Object.keys(properties).forEach(function (key) {
        setProperty(form, key, properties[key]);
      });
    });
  }

  function getFeeVariantId(component, attribute) {
    var value = component.getAttribute(attribute);
    var id = Number(value);
    return Number.isFinite(id) && id > 0 ? id : 0;
  }

  function getFeeItem(component, variantAttribute, unitPriceAttribute, amount) {
    var variantId = getFeeVariantId(component, variantAttribute);
    var unitPrice = Number(component.getAttribute(unitPriceAttribute));
    if (!variantId || unitPrice !== amount * 100 || amount <= 0) return null;
    return { id: variantId, quantity: 1 };
  }

  function getFeeItems(component, profile, mode, sizeAdjustment) {
    var items = [];
    var rushTier = String(mode.adjustment);
    var rushItem = getFeeItem(component, "data-bnd-rush-fee-variant-" + rushTier, "data-bnd-rush-fee-unit-price-" + rushTier, mode.adjustment);
    var sizeTier = sizeAdjustment > 0 ? String(sizeAdjustment) : "";
    var sizeItem = sizeTier ? getFeeItem(component, "data-bnd-size-fee-variant-" + sizeTier, "data-bnd-size-fee-unit-price-" + sizeTier, sizeAdjustment) : null;

    if (rushItem) {
      items.push({
        id: rushItem.id,
        quantity: rushItem.quantity,
        properties: {}
      });
    }
    if (sizeItem) {
      items.push({
        id: sizeItem.id,
        quantity: sizeItem.quantity,
        properties: {}
      });
    }
    return items;
  }

  function getFormProperties(form, component) {
    var properties = {};
    var values = getPropertyValues(component);
    Object.keys(values).forEach(function (key) {
      if (values[key]) properties[key] = values[key];
    });
    return properties;
  }

  function getCartAddUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    return root.replace(/\/?$/, "/") + "cart/add.js";
  }

  function createFeeGroupId() {
    return "bnd-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
  }

  function addProductAndFees(form, component, feeItems, submitter) {
    syncProductVariantId(component);
    var idInput = form && form.querySelector('[name="id"]');
    var quantityInput = form && form.querySelector('[name="quantity"]');
    var variantId = Number(idInput && idInput.value) || getProductVariantId(component);
    var quantity = Number(quantityInput && quantityInput.value) || 1;
    if (!variantId) return Promise.reject(new Error("Product variant is missing."));
    if (idInput) {
      idInput.defaultValue = String(variantId);
      idInput.setAttribute("value", String(variantId));
      idInput.value = String(variantId);
    }

    var feeGroupId = createFeeGroupId();
    var productProperties = getFormProperties(form, component);
    productProperties["_BND group"] = feeGroupId;
    var groupedFeeItems = feeItems.map(function (item) {
      return {
        id: item.id,
        quantity: item.quantity,
        properties: Object.assign({}, item.properties, { "_BND group": feeGroupId })
      };
    });
    var items = [{
      id: variantId,
      quantity: quantity,
      properties: productProperties
    }].concat(groupedFeeItems);

    return fetch(getCartAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: items,
        sections: getCartSections(),
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) throw new Error(payload.description || "Unable to add the product to bag.");
        payload.id = variantId;
        return payload;
      });
    }).then(function (payload) {
      var cartContainer = document.querySelector("cart-notification, cart-drawer");
      if (cartContainer && typeof cartContainer.renderContents === "function") {
        if (submitter && typeof cartContainer.setActiveElement === "function") cartContainer.setActiveElement(submitter);
        try {
          cartContainer.renderContents(payload);
        } catch (error) {
          console.error("Unable to refresh the cart drawer", error);
          window.location.href = (window.routes && window.routes.cart_url) || "/cart";
        }
      }
      document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: payload }));
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: payload }));
      return fetch(((window.routes && window.routes.cart_url) || "/cart") + ".js", { headers: { Accept: "application/json" } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: { cart: cart, source: "bolodoo-native-wedding-dress-form" }
          }));
          return payload;
        })
        .catch(function (error) {
          console.error("Unable to refresh cart state", error);
          return payload;
      });
    });
  }

  function getSelectedFeeItems(component) {
    var size = getSizeSelect(component);
    var root = component.closest("[data-bnd-size-guide-root]");
    var selectedMode = component.querySelector("[data-bnd-mode]:checked") || (root && root.querySelector("[data-bnd-mode]:checked"));
    var profile = getPricingProfile(component);
    var mode = getMode(selectedMode ? selectedMode.value : "standard", profile);
    var sizeAdjustment = size ? profile.sizeAdjustments[size.value] || 0 : 0;
    return getFeeItems(component, profile, mode, sizeAdjustment);
  }

  function getCartSections() {
    var cart = document.querySelector("cart-notification, cart-drawer");
    if (cart && typeof cart.getSectionsToRender === "function") {
      return cart.getSectionsToRender().map(function (section) { return section.id; });
    }
    return ["cart-drawer", "cart-icon-bubble"];
  }

  function getVisibleSizeRows(selectedKey) {
    var index = SIZE_ROWS.findIndex(function (row) { return row.key === selectedKey; });
    if (index < 0) return [];
    var start = Math.max(0, Math.min(index - 1, SIZE_ROWS.length - 3));
    return SIZE_ROWS.slice(start, start + 3);
  }

  function createCell(tagName, text) {
    var cell = document.createElement(tagName);
    cell.textContent = text;
    return cell;
  }

  function renderTable(table, rows, region, unit, selectedKey, showHeight) {
    if (!table) return;
    var caption = table.querySelector("caption");
    table.textContent = "";
    if (caption) table.appendChild(caption);

    var thead = document.createElement("thead");
    var headerRow = document.createElement("tr");
    var headers = ["Size", "Bust", "Waist", "Hips", "Hollow to Floor"];
    if (showHeight) headers.push("Height");
    headers.forEach(function (label) {
      headerRow.appendChild(createCell("th", label));
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);

    var tbody = document.createElement("tbody");
    rows.forEach(function (row) {
      var values = unit === "cm" ? row.cm : row.inch;
      var tableRow = document.createElement("tr");
      tableRow.setAttribute("data-bnd-size-row", row.key);
      if (row.key === selectedKey) tableRow.className = "is-selected";
      tableRow.appendChild(createCell("th", row.regions[region]));
      values.slice(0, showHeight ? 5 : 4).forEach(function (value) {
        tableRow.appendChild(createCell("td", String(value) + " " + (unit === "cm" ? "cm" : "inch")));
      });
      tbody.appendChild(tableRow);
    });
    table.appendChild(tbody);
  }

  function renderSizeGuide(root, component) {
    if (!root) return;
    var state = root._bndGuideState || { region: "US", unit: "inch" };
    var size = getSizeSelect(component);
    var selectedKey = size && SIZE_ROWS.some(function (row) { return row.key === size.value; }) ? size.value : "";
    var preview = getPortalElement(root, "[data-bnd-size-preview]");
    if (preview) preview.hidden = !selectedKey;
    renderTable(getPortalElement(root, '[data-bnd-guide-table="preview"]'), getVisibleSizeRows(selectedKey), state.region, state.unit, selectedKey, false);
    renderTable(getPortalElement(root, '[data-bnd-guide-table="full"]'), SIZE_ROWS, state.region, state.unit, selectedKey, true);

    getPortalElements(root, "[data-bnd-region]").forEach(function (button) {
      var active = button.getAttribute("data-bnd-region") === state.region;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", String(active));
    });
    getPortalElements(root, "[data-bnd-unit]").forEach(function (button) {
      var active = button.getAttribute("data-bnd-unit") === state.unit;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", String(active));
    });

    var currentSize = getSizeSelect(component);
    syncCustomMeasurementPanel(root, currentSize ? currentSize.value : "");
  }

  function setDrawerView(root, view) {
    var activeView = view === "chart" ? "chart" : "select";
    root._bndDrawerView = activeView;
    getPortalElements(root, "[data-bnd-drawer-panel]").forEach(function (panel) {
      var active = panel.getAttribute("data-bnd-drawer-panel") === activeView;
      panel.hidden = !active;
      panel.setAttribute("aria-hidden", String(!active));
    });

    var footer = getPortalElement(root, ".bnd-drawer-footer");
    if (footer) footer.hidden = activeView !== "select";

    var drawer = getPortalElement(root, "[data-bnd-size-drawer]");
    var title = getPortalElement(root, activeView === "chart" ? "[data-bnd-drawer-chart-title]" : "[data-bnd-drawer-title]");
    if (drawer && title && title.id) drawer.setAttribute("aria-labelledby", title.id);

    window.setTimeout(function () {
      var focusTarget = activeView === "chart"
        ? getPortalElement(root, "[data-bnd-size-chart-back]")
        : getPortalElement(root, '[data-bnd-size-option][aria-pressed="true"]') || getPortalElement(root, "[data-bnd-size-option]");
      if (focusTarget) focusTarget.focus();
    }, 20);
  }

  function openDrawer(root, trigger) {
    var drawer = getPortalElement(root, "[data-bnd-size-drawer]");
    var backdrop = getPortalElement(root, "[data-bnd-drawer-backdrop]");
    if (!drawer || !backdrop) return;
    root._bndLastTrigger = trigger;
    setDrawerView(root, "select");
    drawer.hidden = false;
    backdrop.hidden = false;
    drawer.setAttribute("aria-hidden", "false");
    trigger.setAttribute("aria-expanded", "true");
    document.body.classList.add("bnd-drawer-open");
    window.requestAnimationFrame(function () {
      drawer.classList.add("is-open");
      window.setTimeout(function () {
        var size = drawer.querySelector('[data-bnd-size-option][aria-pressed="true"]') || drawer.querySelector("[data-bnd-size-option]");
        if (size) size.focus();
      }, 20);
    });
  }

  function closeDrawer(root, options) {
    var drawer = getPortalElement(root, "[data-bnd-size-drawer]");
    var backdrop = getPortalElement(root, "[data-bnd-drawer-backdrop]");
    if (!drawer || !backdrop || drawer.hidden) return;
    setDrawerView(root, "select");
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    root.querySelectorAll("[data-bnd-size-drawer-trigger]").forEach(function (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    });
    document.body.classList.remove("bnd-drawer-open");
    window.setTimeout(function () {
      drawer.hidden = true;
      backdrop.hidden = true;
    }, 260);
    if (!(options && options.skipFocus) && root._bndLastTrigger) root._bndLastTrigger.focus();
  }

  function cancelSizeDrawer(root) {
    if (root) root._bndPendingAddForm = null;
    var size = root && getPortalElement(root, "[data-bnd-size]");
    syncConfirmLabel(root, size ? size.value : "");
    closeDrawer(root);
  }

  function submitSelectedProduct(component, form, submitter) {
    syncProductVariantId(component);
    disableYmqProductForm(component);
    render(component);
    syncProperties(component);

    var button = submitter || (form && form.querySelector('[type="submit"]'));
    if (button) button.disabled = true;
    return addProductAndFees(form, component, getSelectedFeeItems(component), button).catch(function (error) {
      console.error("Unable to add wedding dress fees", error);
      window.alert("We could not add this item to your bag. Please try again.");
    }).finally(function () {
      if (button) button.disabled = false;
      component._bndAddInFlight = false;
    });
  }

  /* 从加车打开尺码弹框时，选中尺码后需再点右下角加车按钮才加车并关闭弹框。 */
  function addToCartAfterSizePick(root, component) {
    if (!root || !root._bndPendingAddForm || component._bndAddInFlight) return false;
    var size = getSizeSelect(component);
    if (!size || !size.value) return false;
    if (size.value === "Custom Size" && !areCustomMeasurementsComplete(root)) return false;

    var form = root._bndPendingAddForm;
    root._bndPendingAddForm = null;
    if (!form || typeof form.querySelector !== "function") return false;

    component._bndAddInFlight = true;
    closeDrawer(root, { skipFocus: true });
    submitSelectedProduct(component, form);
    return true;
  }

  function render(component) {
    var root = component.closest("[data-bnd-size-guide-root]");
    var selectedMode = component.querySelector("[data-bnd-mode]:checked");
    var modeKey = selectedMode ? selectedMode.value : "standard";
    var profile = getPricingProfile(component);
    var mode = getMode(modeKey, profile);
    var sizeSelect = getSizeSelect(component);
    var sizeValue = sizeSelect ? sizeSelect.value : "";
    var sizeAdjustment = profile.sizeAdjustments[sizeValue] || 0;
    var start = new Date();
    start = new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate()));
    var standard = SHIPPING.standard;
    var expedited = SHIPPING.expedited;
    var standardText = deliveryRange(start, mode, standard);
    var expeditedText = deliveryRange(start, mode, expedited);
    var countryCode = getCountryCode();
    var countryName = COUNTRY_NAMES[countryCode] || COUNTRY_NAMES.US;
    var totalAdjustment = mode.adjustment + sizeAdjustment;
    var basePrice = getBasePriceCents(component);
    var currency = component.getAttribute("data-currency") || "USD";
    var selectedSizeText = root && root.querySelector("[data-bnd-selected-size]");

    component._bndEstimate = {
      tailoring: tailoringLabel(mode),
      standard: standardText,
      expedited: expeditedText
    };
    component._bndCountryName = countryName;
    if (selectedSizeText) selectedSizeText.textContent = sizeValue || "Select A Size";
    var selectedColorText = component.querySelector("[data-bnd-color]");
    var selectedSummarySize = component.querySelector("[data-bnd-summary-size]");
    var selectedColor = getSelectedColor(component);
    syncSizeButtons(root, sizeValue);

    var country = component.querySelector("[data-bnd-country]");
    var tailoring = component.querySelector("[data-bnd-tailoring]");
    var standardDate = component.querySelector("[data-bnd-standard-date]");
    var expeditedDate = component.querySelector("[data-bnd-expedited-date]");
    var standardTime = component.querySelector("[data-bnd-standard-time]");
    var expeditedTime = component.querySelector("[data-bnd-expedited-time]");
    var plusSizeFee = component.querySelector("[data-bnd-plus-size-fee]");
    var rushOrderFee = component.querySelector("[data-bnd-rush-order-fee]");
    var total = component.querySelector("[data-bnd-total]");

    if (selectedColorText && selectedColor) selectedColorText.textContent = selectedColor;
    if (selectedSummarySize) selectedSummarySize.textContent = sizeValue || "Select A Size";
    if (country) country.textContent = countryName;
    if (tailoring) tailoring.textContent = component._bndEstimate.tailoring;
    if (standardDate) standardDate.textContent = standardText;
    if (expeditedDate) expeditedDate.textContent = expeditedText;
    if (standardTime) standardTime.textContent = "Shipping Time: " + standard[0] + "-" + standard[1] + " Business Days";
    if (expeditedTime) expeditedTime.textContent = "Shipping Time: " + expedited[0] + "-" + expedited[1] + " Business Days";
    if (plusSizeFee) {
      plusSizeFee.hidden = sizeAdjustment <= 0;
      plusSizeFee.querySelector("span").textContent = formatAdjustment(sizeAdjustment);
    }
    if (rushOrderFee) {
      rushOrderFee.hidden = mode.adjustment <= 0;
      rushOrderFee.querySelector("span").textContent = formatAdjustment(mode.adjustment);
    }
    if (total) total.textContent = formatCurrency(basePrice + totalAdjustment * 100, currency);

    renderSizeGuide(root, component);
    syncProperties(component);
  }

  function bindDrawer(root, component) {
    if (!root || root.dataset.bndDrawerBound === "true") return;
    root.dataset.bndDrawerBound = "true";
    hoistDrawer(root);
    root._bndGuideState = { region: "US", unit: "inch" };
    root._bndDrawerView = "select";
    function handleClick(event) {
      var trigger = event.target.closest("[data-bnd-size-drawer-trigger]");
      if (trigger) {
        event.preventDefault();
        root._bndPendingAddForm = null;
        var selectedSize = getPortalElement(root, "[data-bnd-size]");
        syncConfirmLabel(root, selectedSize ? selectedSize.value : "");
        openDrawer(root, trigger);
        return;
      }
      var sizeOption = event.target.closest("[data-bnd-size-option]");
      if (sizeOption) {
        event.preventDefault();
        var sizeValue = sizeOption.getAttribute("data-size-value");
        chooseSize(root, component, sizeValue);
        return;
      }
      var confirm = event.target.closest("[data-bnd-confirm-size]");
      if (confirm) {
        event.preventDefault();
        if (confirm.disabled) return;
        if (root._bndPendingAddForm) {
          addToCartAfterSizePick(root, component);
          return;
        }
        closeDrawer(root);
        return;
      }
      var chartTrigger = event.target.closest("[data-bnd-view-size-chart]");
      if (chartTrigger) {
        event.preventDefault();
        setDrawerView(root, "chart");
        return;
      }
      var chartBack = event.target.closest("[data-bnd-size-chart-back]");
      if (chartBack) {
        event.preventDefault();
        setDrawerView(root, "select");
        return;
      }
      var regionButton = event.target.closest("[data-bnd-region]");
      if (regionButton) {
        root._bndGuideState.region = regionButton.getAttribute("data-bnd-region");
        renderSizeGuide(root, component);
        return;
      }
      var unitButton = event.target.closest("[data-bnd-unit]");
      if (unitButton) {
        root._bndGuideState.unit = unitButton.getAttribute("data-bnd-unit");
        renderSizeGuide(root, component);
        return;
      }
      if (event.target.closest("[data-bnd-drawer-close]") || event.target.closest("[data-bnd-drawer-backdrop]")) {
        cancelSizeDrawer(root);
      }
    }
    root.addEventListener("click", handleClick);
    var drawer = getPortalElement(root, "[data-bnd-size-drawer]");
    if (root._bndPortal) root._bndPortal.addEventListener("click", handleClick);

    function handleChange(event) {
      if (event.target.matches("[data-bnd-size]")) render(component);
    }
    root.addEventListener("change", handleChange);
    if (drawer) drawer.addEventListener("change", handleChange);

    function handleInput(event) {
      if (!event.target.matches("[data-bnd-measurement]")) return;
      var size = getSizeSelect(component);
      syncSizeButtons(root, size ? size.value : "");
      syncProperties(component);
    }
    root.addEventListener("input", handleInput);
    if (drawer) drawer.addEventListener("input", handleInput);
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") cancelSizeDrawer(root);
    });
  }

  function bind(component) {
    if (component.dataset.bndBound === "true") return;
    component.dataset.bndBound = "true";
    var root = component.closest("[data-bnd-size-guide-root]");
    hoistDrawer(root);
    var sizeSelect = getSizeSelect(component);
    if (sizeSelect && component.dataset.bndSizeChosen !== "true") {
      sizeSelect.value = "";
      sizeSelect.selectedIndex = 0;
    }
    hideThemeSizePicker();

    component.addEventListener("change", function (event) {
      if (event.target.matches("[data-bnd-size], [data-bnd-mode]")) render(component);
    });
    component.addEventListener("input", function (event) {
      if (event.target.matches("[data-bnd-requirements]")) syncProperties(component);
    });

    if (!component._bndVariantChangeWatch) {
      component._bndVariantChangeWatch = function (event) {
        if (!event.target.closest || !event.target.closest("variant-radios")) return;
        window.setTimeout(function () {
          syncProductVariantId(component);
          render(component);
        }, 0);
      };
      document.addEventListener("change", component._bndVariantChangeWatch);
    }

    findProductForms(component).forEach(function (form) {
      form.addEventListener("formdata", function (event) {
        appendPropertiesToFormData(component, event.formData);
      });
      form.addEventListener("submit", function () {
        syncProductVariantId(component);
        disableYmqProductForm(component);
        render(component);
        syncProperties(component);
      }, true);
      form.addEventListener("submit", function (event) {
        var size = getSizeSelect(component);
        if (size && size.value === "Custom Size" && !areCustomMeasurementsComplete(root)) {
          event.preventDefault();
          root._bndPendingAddForm = form;
          // BOLODOO incomplete custom measurements submit guard v1: prevent downstream theme handlers from submitting.
          event.stopImmediatePropagation();
          syncConfirmLabel(root, size.value);
          var trigger = root && root.querySelector("[data-bnd-size-drawer-trigger]");
          if (trigger) openDrawer(root, trigger);
        }
      }, true);
      form.addEventListener("submit", function (event) {
        if (event.defaultPrevented) return;
        var size = getSizeSelect(component);
        if (!size || !size.value) {
          event.preventDefault();
          event.stopImmediatePropagation();
          root._bndPendingAddForm = form;
          syncConfirmLabel(root, "");
          var trigger = root && root.querySelector("[data-bnd-size-drawer-trigger]");
          if (trigger) openDrawer(root, trigger);
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        root._bndPendingAddForm = null;
        submitSelectedProduct(component, form, event.submitter || form.querySelector('[type="submit"]'));
      }, true);
    });

    component._bndCustomMeasurementsComplete = function () {
      return areCustomMeasurementsComplete(root);
    };
    bindDrawer(root, component);
    disableYmqProductForm(component);
    watchNativeProductForm(component);
    render(component);
    window.setTimeout(function () { render(component); }, 300);
  }

  function hideYmq() {
    document.querySelectorAll('[class*="ymq-option"]').forEach(function (element) {
      element.hidden = true;
    });
  }

  function init() {
    document.querySelectorAll("[data-bolodoo-native-wedding-dress]").forEach(function (component) {
      bind(component);
      hideThemeSizePicker();
      disableYmqProductForm(component);
    });
    hideYmq();
  }

  init();
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("shopify:section:load", init);
})();
